import { useModal } from 'react-modal-hook'
import { useState } from 'react'
import { Button } from 'src/components/ui'
import { useUpdateSubscriptionMutation } from 'site/opc-ua-connection/opc-ua-connection.api'
import { ConfirmModal } from '../ConfirmModal'

type Props = {
  gatewayId: string
  siteId: string
  connectionId: string
  subscriptionId: string
  getNodesToChange: () => {
    nodesToAdd: string[]
    nodesToRemove: string[]
  }
  onSuccess: () => void
  nodesAdded: number
  nodesRemoved: number
  isDisabled: boolean
}

export function SaveSubscriptionButton({
  gatewayId,
  siteId,
  connectionId,
  subscriptionId,
  onSuccess,
  getNodesToChange,
  nodesAdded,
  nodesRemoved,
  isDisabled,
}: Props): JSX.Element {
  const [isConfirmLoading, setIsConfirmLoading] = useState(false)
  const subscriptionMutation = useUpdateSubscriptionMutation(
    gatewayId,
    siteId,
    connectionId,
    subscriptionId,
  )

  // Confirm changes modal
  const [showEditSubscriptionModal, closeEditSubscriptionModal] =
    useModal(() => {
      const handleConfirm = async (): Promise<void> => {
        setIsConfirmLoading(true)
        const { nodesToAdd, nodesToRemove } = getNodesToChange()
        await subscriptionMutation.mutateAsync(
          {
            toSubscribe: nodesToAdd,
            toUnsubscribe: nodesToRemove,
          },
          {
            onSuccess: data => {
              closeEditSubscriptionModal()
              setIsConfirmLoading(false)
              onSuccess()
            },
            onError: () => {
              setIsConfirmLoading(false)
            },
          },
        )
      }
      return (
        <ConfirmModal
          isError={subscriptionMutation.isError}
          isLoading={isConfirmLoading}
          onClose={closeEditSubscriptionModal}
          onConfirm={handleConfirm}
          tagsAdded={nodesAdded}
          tagsRemoved={nodesRemoved}
        />
      )
    }, [
      subscriptionMutation.isError,
      nodesAdded,
      nodesRemoved,
      isConfirmLoading,
    ])

  return (
    <Button
      disabled={isDisabled || (nodesAdded === 0 && nodesRemoved === 0)}
      variant="primary"
      title="Save Changes"
      onClick={showEditSubscriptionModal}
    />
  )
}
